// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"ResetBtn_resetBtn__1hSKp"};